import dayjs from "dayjs";
import { IShop } from "interfaces";

export function getSchedule(data?: IShop) {
  return data?.shop_working_days?.find(
    (item) => item.day?.toLowerCase() === dayjs().format("dddd").toLowerCase(),
  );
}
